<template>
    <div class="shopHome">
        <el-dialog title="" :visible.sync="dialogVisible" @close="cancel" width="404px">
            <div class="shopBox bg_mobile">
                <div class="viewBox">
                    <div class="top">
                        <img :src="require('@/common/images/shop/view-top.png')" alt="">
                        <div class="shopName">{{shopName}}</div>
                    </div>
                    <div class="content" v-if="item.pagejson&&item.pagejson.complist">
                        <div v-for="(obj,index) in item.pagejson.complist" :key="index">
                            <component :is="item.pagejson.clienttype+obj.comtype" :setting="obj"></component>
                        </div>
                    </div>
                    <div class="navigator">
                        <div class="navItem" v-for="(obj, index) in item.sublist" :key="index">
                            <img v-lazy="obj.barimgurl" alt="">
                            <p>{{obj.barname}}</p>
                        </div>
                    </div>
                </div>
            </div>
        <!--<div class="actionBox">-->
            <!--<el-button type="primary" @click.native="setUpShopHome">搭建店铺首页</el-button>-->
            <!--<div class="msgBox">-->
                <!--<p>左图是您店铺当前的预览效果。</p>-->
                <!--<p>主页是用户看到店铺的第一印象，您可以用店铺装修中的组件自由组合，搭建个性化的店铺主页。</p>-->
                <!--<p>店铺主页支持同时应用于店铺和小程序。<span>搭建店铺主页教程</span></p>-->
            <!--</div>-->
        <!--</div>-->
        <!-- <shop-mob-banner-setting></shop-mob-banner-setting> -->
        </el-dialog>
    </div>
</template>
<script>
import {getAllMicroPageView, getMicroPageNavView} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import ShopMobBannerSetting from '@/views/shopMgt/mob/page/setting/shopMobBannerSetting'
import ShopMobBanner from 'views/shopMgt/mob/page/components/shopMobBanner'
import ShopMobKnowledge from 'views/shopMgt/mob/page/components/shopMobKnowledge'
import ShopMobVlive from 'views/shopMgt/mob/page/components/shopMobVlive'
import ShopMobActivity from 'views/shopMgt/mob/page/components/shopMobActivity'
import ShopMobNavigation from 'views/shopMgt/mob/page/components/shopMobNavigation'
import ShopMobStar from 'views/shopMgt/mob/page/components/shopMobStar'
import ShopMobStarSubject from 'views/shopMgt/mob/page/components/shopMobStarSubject'
import ShopMobCoupon from 'views/shopMgt/mob/page/components/shopMobCoupon'
import ShopMobStarSearch from 'views/shopMgt/mob/page/components/shopMobSearch'
// import ShopMobStarSubject from 'views/shopMgt/mob/page/components/shopMobStarSubject'
export default {
    name: 'shopHome',
    data() {
        return {
            dialogVisible: false,
            shopName: '资鲸店铺',
            navData: [
                {defaultIcon: require('@/common/images/home/icon_home_default@2x.png'), title: '首页'},
                {defaultIcon: require('@/common/images/home/icon_home_default@2x.png'), title: '首页'},
                {defaultIcon: require('@/common/images/home/icon_home_default@2x.png'), title: '首页'}
            ],
            item: {
                homeinnerid: '',
                pagejson: {
                    pageinnerid: '',
                    clienttype: '',
                    pagename: '',
                    isdefault: 0,
                    complist: []
                },
                sublist: []
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.item.homeinnerid = row.homeinnerid
            this.dialogVisible = true
            this._getList()
        },
        cancel() {

        },
        _getView(innerid) {
            this.setLoading(true)
            getAllMicroPageView({
                data: {
                    innerid: innerid,
                    homeinnerid: this.item.homeinnerid
                },
                success: data => {
                    this.item.pagejson = data.data.pagejson
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getMicroPageNavView({
                data: {innerid: this.item.homeinnerid},
                success: data => {
                    this.item.sublist = data.data.sublist
                    this.setLoading(false)
                    if (this.item.sublist.length > 0) {
                        if (this.item.sublist[0].urltype === 6) {
                            this._getView('')
                        } else {
                            this._getView(this.item.sublist[0].urlkeyid)
                        }
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        setUpShopHome() {
            if (this.item.pageinnerid) {
                this.$router.push({name: 'MicroPageEdit', query: {id: this.item.pageinnerid}})
            } else {
                this.$router.push({name: 'MicroPageEdit', query: {isdefault: 1}})
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        // ShopMobBannerSetting
        mobileimagead: ShopMobBanner,
        mobileknowledge: ShopMobKnowledge,
        mobilealive: ShopMobVlive,
        mobileactivity: ShopMobActivity,
        mobilecategorynav: ShopMobNavigation,
        mobilestar: ShopMobStar,
        mobilestarsubject: ShopMobStarSubject,
        mobilecoupon: ShopMobCoupon,
        mobilesearchbar: ShopMobStarSearch,
        mobilestarsubject: ShopMobStarSubject
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .shopHome{
        .el-dialog{
            background: transparent !important;
            box-shadow: 0 0 0 rgba(0,0,0,0);
        }
        .el-dialog__headerbtn{
            top: -80px !important;
            right: -10px !important;
            font-size: 24px !important;
            color: #fff !important;
        }
        .el-dialog__body{
            padding: 0 !important;
        }
        .el-dialog .el-dialog__header{
            /*display: none !important;*/
            border-bottom: 0px solid #DCDFE6
        }
        .shopBox{
            margin-top: -90px;
            width: 404px;
            height: 849px;
            overflow: hidden;
            border-radius: 20px;
        }
        .viewBox{
            padding: 93px 14px 89px 14px;
            height: 668px;
            position: relative;
            overflow: hidden;
            .top{
                position: relative;
                height: 64px;
                img{
                    width: 375px;
                    height: 64px;
                }
                .shopName{
                    position: absolute;
                    width: 375px;
                    text-align: center;
                    bottom: 16px;
                }
            }
            .content{
                height: 554px;
                width: 397px;
                position: absolute;
                overflow-y: scroll;
                overflow-x: hidden;
            }
            .navigator{
                display: flex;
                height: 50px;
                width: 377px;
                position: absolute;
                box-sizing: border-box;
                padding: 7px 0;
                bottom: 93px;
                .navItem{
                    flex: 1;
                    text-align: center;
                    color: #909399;
                    font-size: 12px;
                    img{
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
        .actionBox{
            padding-left: 25px;
            .msgBox{
                margin-top: 30px;
                line-height: 30px;
                color:#909399;
                p{
                    span{
                        color: #409EFF;
                    }
                }
            }
        }
    }
</style>
